import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { toastr } from '@/utils/toast'

import config from '@/config/config-esm'
import { checkIfLoggedIn } from '@/services/auth'

const SignInForm = () => {
  const dispatch = useDispatch()
  const anon = useSelector((state) => state.anon)
  
  const [identity, setIdentity] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const signIn = (e) => {
    e.preventDefault()
    axios
      .post(`${config.apiUrl}/authenticate`, { identity, password })
      .then((r) => {
        if (r.data.data.token) {
          const myStorage = window.localStorage
          myStorage.setItem('token', `Bearer ${r.data.data.token}`)
          checkIfLoggedIn({ dispatch })
        } else {
          setError('Sorry, error signing you in. Please try again.')
        }
      })
      .catch((e) => {
        console.error('error: ', e)
        toastr.error('Kunne ikke logge inn', `Prøv igjen eller kontakt teamleader`)
      })
  }

  return (
    <form onSubmit={(e) => signIn(e)}>
      <div className="input_wrapper">
        <input
          type="text"
          placeholder="Brukernavn/Epost/Tlf.nr."
          required
          value={identity}
          onChange={(e) => {
            setIdentity(e.target.value)
          }}
        />
      </div>
      <div className="input_wrapper">
        <input
          type="password"
          placeholder="Passord"
          required
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
          }}
        />
      </div>
      <span>{error}</span>
      <button className="login">Logg inn</button>
    </form>
  )
}

export default SignInForm
